/**
 * AccordionBody - collapsible body panel of an accordion item.
 * Custom element: <accordion-body>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class AccordionBody extends ThemeComponent {}
setFunctionName(AccordionBody, "AccordionBody");
const propertyTypes = {};
AccordionBody.prototype.$name = "AccordionBody";
AccordionBody.prototype.$info = JSON.parse('{"name":"AccordionBody","meta":{"isLegacy":false,"selector":"accordion-body"},"props":[],"refs":[]}');
AccordionBody.prototype.$info.component = AccordionBody;
for (const prop of AccordionBody.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Accordion/AccordionBody.ts", {
  AccordionBody: AccordionBody
}, void 0);